<div>
    <div class="elementor-element elementor-element-51dc4360 elementor-button-align-stretch elementor-widget elementor-widget-form" data-id="51dc4360" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default"
         v-if="submissionSuccess" style="padding-top: 55px; padding-bottom: 55px;">
        <h4>
            Your query has been submitted successfully.
        </h4>
    </div>
    <div class="elementor-widget-container" v-if="!submissionSuccess">
        <form class="elementor-form" >
            <div class="elementor-form-fields-wrapper elementor-labels-">
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-firstName" class="elementor-field-label elementor-screen-only">
                        Name
                    </label>
                    <div class="text-danger" v-if="name.hasError">
                        {{name.errorMessage}}
                    </div>
                    <input type="text" id="form-field-firstName" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Name" required="required" aria-required="true" v-model="name.value">
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-email" class="elementor-field-label elementor-screen-only">
                        Email Address
                    </label>
                    <div class="text-danger" v-if="emailAddress.hasError">
                        {{emailAddress.errorMessage}}
                    </div>
                    <input type="email" id="form-field-email" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Email Address" required="required" aria-required="true" v-model="emailAddress.value">
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-phoneNumber" class="elementor-field-label elementor-screen-only">
                        Mobile Number
                    </label>
                    <div class="text-danger" v-if="mobileNumber.hasError">
                        {{mobileNumber.errorMessage}}
                    </div>
                    <input type="text" id="form-field-phoneNumber" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Mobile Number" required="required" aria-required="true" v-model="mobileNumber.value">
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-cardBarcode" class="elementor-field-label elementor-screen-only">
                        Card Barcode
                    </label>
                    <div class="text-danger" v-if="cardBarcodeNumber.hasError">
                        {{cardBarcodeNumber.errorMessage}}
                    </div>
                    <input type="text" id="form-field-cardBarcode" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Card Barcode" required="required" aria-required="true" v-model="cardBarcodeNumber.value">
                </div>
                <dropdown
                        :selectOptions="sites"
                        :selectedOption="selectedSiteId"
                        :elementId="'siteDropdown'"
                        :placeholder="'Select Site'"
                        @changeSelect="onSiteDropdownChange"></dropdown>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-message" class="elementor-field-label elementor-screen-only">
                        How can we help you?
                    </label>
                    <div class="text-danger" v-if="message.hasError">
                        {{message.errorMessage}}
                    </div>
                    <textarea id="form-field-message" rows="5" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="How can we help you?" required="required" aria-required="true" v-model="message.value"></textarea>
                </div>
                <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                    <button type="submit" class="elementor-button elementor-size-sm" :disabled="loading" @click="sendLogQuery">
                        <span>
                            <span class=" elementor-button-icon">
                            </span>
                            <span class="elementor-button-text">Submit</span>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
